module.exports = __webpack_public_path__ + "img/rampa_lancio.8b38ef22.png";